import React from "react";
import { Group, Rect, Text } from "react-konva";
import { MondayItemColumn } from "../../controller";
import { FONT_SIZE, COLUMN_HEIGHT, COLUMN_PADDING, COLUMN_WIDTH } from "../../consts";
import { getColumnDisplayValue } from "elements/monday-task/utils";

interface GenericColumnProps {
  column: MondayItemColumn;
  x: number;
}

export const GenericColumn = React.memo(({ column, x }: GenericColumnProps) => {
  const text = getDisplayValue(column);

  return (
    <Group>
      <Rect x={x} width={COLUMN_WIDTH} height={COLUMN_HEIGHT} fill="#F6F7FB" cornerRadius={6} />
      <Text
        x={x + COLUMN_PADDING}
        y={1}
        text={text}
        fontSize={FONT_SIZE}
        fill="#7F869B"
        fontFamily="Poppins"
        letterSpacing={0.124}
        width={COLUMN_WIDTH - 2 * COLUMN_PADDING}
        height={COLUMN_HEIGHT}
        align="center"
        verticalAlign="middle"
        ellipsis={true}
        wrap="none"
      />
    </Group>
  );
});

GenericColumn.displayName = "GenericColumn";

function getDisplayValue(column: MondayItemColumn): string {
  return getColumnDisplayValue(column);
}
